import styled from 'styled-components';
import { title3 } from '../../../theme/cssSnippets';

const Legend = styled.legend`
    ${title3}
`;

export default Legend;
